// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__tBas+","iconContainer":"header_iconContainer__e8unL","avtar":"header_avtar__IxU1e","greetingContainer":"header_greetingContainer__gfki2"};